import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full" }
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = { class: "text-3xl font-extrabold leading-8 mb-1 text-top" }
const _hoisted_4 = { class: "text-lg font-semibold opacity-80 leading-6 text-top-faded" }
const _hoisted_5 = { class: "flex-1 px-2 py-4 overflow-y-auto" }
const _hoisted_6 = { class: "h-full flex-col justify-between" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs flex flex-col space-y-2 text-center mt-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Henter samtaler...", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-lg mx-3 mt-3 mb-1.5 text-primary" }, "Nylige samtaler", -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center py-2 text-xs text-primary" }, [
  /*#__PURE__*/_createTextVNode(" Drevet av "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "font-semibold text-primary-faded",
    target: "_blank",
    href: "https://www.webhuset.no/chat"
  }, "Webhuset Chat")
], -1)

import NavigationHeader from "@/features/shared/NavigationHeader.vue";
import PreviousConversationItem from "@/features/splash-screen/PreviousConversationItem.vue";
import { getCurrentInstance, inject, ref } from "vue";
import conversationHistoryPersistence, { ConversationHistory } from "@/utils/conversationHistoryPersistence";
import { useContactPersistence } from "@/utils/contactPersistence";
import { useGraphqlSdk } from "@/graphql/graphql-client";
import { formatDate } from "@/utils/date";
import ActionButton from "@/features/shared/ActionButton.vue";
import { useEmitterOn } from "@/composables/useEmitterOn";
import SpinnerAnimation from "../shared/SpinnerAnimation.vue";
import { settingsInjectionKey, demoModeInjectionKey } from "@/keys";


export default /*#__PURE__*/_defineComponent({
  __name: 'SplashScreen',
  emits: ["start-conversation", "close", "click"],
  setup(__props, { emit: __emit }) {

/* eslint-disable @typescript-eslint/no-explicit-any */
const emits = __emit;

const instance = getCurrentInstance();
const tenant = instance?.appContext.config.globalProperties.$tenant;

const contactPersistence = useContactPersistence(tenant);
const loading = ref(false);

const settings = inject(settingsInjectionKey);
const demoMode = inject(demoModeInjectionKey);

const conversationHistory = ref<ConversationHistory[]>([]);
conversationHistory.value = demoMode
  ? [{ content: "Hei og velkommen til chat'en vår!", conversation: "test", date: Date.now(), ended: false }]
  : conversationHistoryPersistence.getState() ?? [];

const contact = ref();
contact.value = contactPersistence.getState();

if (contact.value && conversationHistory.value.length === 0) {
  loading.value = true;

  void useGraphqlSdk()
    .GetConversations({
      contact: contact.value,
      tenant: tenant,
      take: 30,
    })
    .then(res => {
      conversationHistory.value = res.conversations.map(i => {
        return {
          conversation: i.id,
          content: i.lastMessageContent ?? "",
          date: Date.parse(i.updated),
          ended: false,
        };
      });

      conversationHistoryPersistence.saveState(conversationHistory.value);
    })
    .finally(() => {
      loading.value = false;
    });
}

function onStartConversationClick() {
  emits("start-conversation");
}

function onCloseClick() {
  emits("close");
}

function onConversationClick(conversation: string) {
  emits("click", conversation);
}

useEmitterOn("messages-updated", () => {
  conversationHistory.value = conversationHistoryPersistence.getState() ?? [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavigationHeader, { onClose: onCloseClick }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(settings)?.text?.splashHeaderText), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(settings)?.text?.splashSubHeaderText), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createVNode(ActionButton, {
            class: "w-full",
            onClick: onStartConversationClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Start en samtale ")
            ]),
            _: 1
          })
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(SpinnerAnimation, { class: "mx-auto" }),
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        (conversationHistory.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversationHistory.value, (conversation) => {
                return (_openBlock(), _createBlock(PreviousConversationItem, {
                  key: conversation.conversation,
                  onClick: ($event: any) => (onConversationClick(conversation.conversation))
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: conversation.content
                    }, null, 8, _hoisted_11)
                  ]),
                  date: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(formatDate)(conversation.date)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_12
  ]))
}
}

})